import { DEFAULT_RPC, RPC_DEFAULT_KEY } from '@/config';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

interface PersistStore {
  rpcUrl: string;
  rpcKey: string;
  rpcError: boolean;
  confirmDisclaimer: boolean;
  confirmLock: boolean;
  confirmLockUserList: Record<string, boolean>;
  coingeckoPrices: { [key: string]: number };
  memeSlippage: string;
  agentSlippage: string;
  creatingToken: any;
}

export interface MultisigAction {
  handleSetCreatingToken: (creatingToken: any) => void;
  handleSetMemeSlippage: (slippage: string) => void;
  handleSetAgentSlippage: (slippage: string) => void;
  handleSetRpcUrl: (rpcUrl: string) => void;
  handleSetRpcKey: (rpcKey: string) => void;
  handleSetRpcError: (rpcError: boolean) => void;
  handleSetConfirmDisclaimer: (confirmDisclaimer: boolean) => void;
  handleSetConfirmLockUser: (confirmLock: boolean) => void;
  handleSetCoingeckoPrices: (coingeckoPrices: {
    [key: string]: number;
  }) => void;
  handleSetConfirmLockUserList: (
    confirmLockUserList: Record<string, boolean>,
  ) => void;
}

const initialState = {
  rpcUrl: DEFAULT_RPC,
  rpcKey: RPC_DEFAULT_KEY,
  rpcError: false, // not persisted
  confirmDisclaimer: false,
  confirmLock: false,
  coingeckoPrices: {},
  memeSlippage: '0.3',
  agentSlippage: '0.3',
  creatingToken: null,
  confirmLockUserList: {},
};

const usePersistStore = create<PersistStore & { actions: MultisigAction }>()(
  persist(
    immer((set) => ({
      //States
      ...initialState,

      //Actions
      actions: {
        handleSetCreatingToken: (creatingToken: any) => set({ creatingToken }),
        handleSetMemeSlippage: (slippage) => set({ memeSlippage: slippage }),
        handleSetAgentSlippage: (slippage) => set({ agentSlippage: slippage }),
        handleSetRpcUrl: (rpcUrl) => set({ rpcUrl }),
        handleSetRpcKey: (rpcKey) => set({ rpcKey }),
        handleSetRpcError: (rpcError) => set({ rpcError }),
        handleSetConfirmDisclaimer: (confirmDisclaimer) =>
          set({ confirmDisclaimer }),
        handleSetConfirmLockUser: (confirmLock) => set({ confirmLock }),
        handleSetConfirmLockUserList: (confirmLockUserList) =>
          set({ confirmLockUserList }),
        handleSetCoingeckoPrices: (coingeckoPrices) => set({ coingeckoPrices }),
      },
    })),
    {
      name: 'Zus:AgentsLand',
      partialize: ({
        rpcKey,
        rpcUrl,
        confirmDisclaimer,
        coingeckoPrices,
        memeSlippage,
        agentSlippage,
        creatingToken,
        confirmLock,
        confirmLockUserList,
      }) => ({
        rpcUrl,
        rpcKey,
        confirmDisclaimer,
        coingeckoPrices,
        memeSlippage,
        agentSlippage,
        creatingToken,
        confirmLock,
        confirmLockUserList,
      }),
    },
  ),
);

export default usePersistStore;
